import { Avatar, Box, Card, IconButton, Modal, Typography } from '@mui/material'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import CloseIcon from '@mui/icons-material/Close'

export const DeleteTaskModal = ({ onCancel, onConfirm }) => {
	return (
		<Modal open={true}>
			<Box
				sx={{
					display: 'flex',
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: '50rem',
					height: '30rem',
					borderRadius: '1rem',
				}}
			>
				<Card
					sx={{
						display: 'flex',
						flexGrow: 1,
						borderRadius: '1rem',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						backgroundColor: '#FAF4F2',
					}}
				>
					<IconButton
						sx={{
							color: 'white',
							position: 'absolute',
							backgroundColor: '#e8ebee',
							borderRadius: '50%',
							padding: '1rem',
							right: '1rem',
							top: '1rem',
						}}
						onClick={onCancel}
					>
						<CloseIcon sx={{ color: '#282828' }} />
					</IconButton>
					<Avatar
						sx={{
							backgroundColor: 'white',
							width: '4em',
							height: '4em',
							margin: '1em',
						}}
					>
						<DeleteOutlineOutlinedIcon
							sx={{
								color: '#7ca6bd',
								width: '2em',
								height: '2em',
							}}
						/>
					</Avatar>
					<Typography variant="h2" gutterBottom>
						Delete Task
					</Typography>
					<Typography variant="h6" gutterBottom>
						Are you sure you want to delete this task?
					</Typography>
					<button
						onClick={onConfirm}
						data-cy="confirmDeleteTaskButton"
					>
						Delete
					</button>
				</Card>
			</Box>
		</Modal>
	)
}
